/**
 * Title-case labels from master data (ALL CAPS, all lower, etc.) for UI display only.
 */
export function toTitleCase(value) {
  if (value == null || value === '') {
    return '';
  }

  return String(value)
    .trim()
    .toLowerCase()
    .replace(/\b[\w']+/g, (word) => word.charAt(0).toUpperCase() + word.slice(1));
}

export function formatDisplayName(...parts) {
  return parts
    .filter((part) => part != null && String(part).trim() !== '')
    .map((part) => toTitleCase(part))
    .join(' ');
}
